import React, { Component } from 'react';

// Components
import { Card, Table, Button, Icon, Empty, Modal, Spin } from 'antd';
import InvitedUsersTable from './InvitedUsersTable';

const ButtonGroup = Button.Group;
class UsersTab extends Component {
    state = {
        deleteModalShown: false,
        deleteModalIsLoading: false,
        recordToDelete: null
    };

    onDeleteModalShownToggle = (isShown, record) => () => {
        this.setState({ deleteModalShown: isShown, recordToDelete: record || null });
    };

    onDeleteModalStateReset = () => {
        this.setState(() => ({
            deleteModalShown: false,
            deleteModalIsLoading: false,
            recordToDelete: null
        }));
    };

    toggleAddOrEditModal = () => {
        const { onInviteNewResidentModalIsShown } = this.props;
        onInviteNewResidentModalIsShown(true);
    };

    onDeleteUser = () => {
        this.setState({ deleteModalIsLoading: true });

        const { recordToDelete } = this.state;
        const { params, fetchHomeDetail, handleDeleteUser } = this.props;
        handleDeleteUser(recordToDelete.id, params).then(() => {
            this.onDeleteModalStateReset();
            fetchHomeDetail(params);
        });
    };

    render() {
        const {
            isLoading,
            userList,
            msgs,
            ownerData,
            params,
            isAdmin = false,
            isOwnerOfHouse = false,
            isInstaller = false
        } = this.props;
        const { recordToDelete, deleteModalShown, deleteModalIsLoading } = this.state;
        const userListSorted = [
            ...(ownerData ? [ownerData.toJS()] : []),
            ...(userList ? userList.toJS() : [])
        ].sort((ownerA, ownerB) => {
            const surnameDiff =
                (ownerA.surename > ownerB.surename) - (ownerA.surename < ownerB.surename);
            return surnameDiff === 0
                ? (ownerA.name > ownerB.name) - (ownerA.name < ownerB.name)
                : surnameDiff;
        });
        const columns = [
            {
                title: msgs.homes.detail.userSurname,
                dataIndex: 'surename',
                key: 'surename'
            },
            {
                title: msgs.homes.detail.userName,
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: msgs.homes.detail.owner,
                dataIndex: 'id',
                key: 'id',
                render: id => <Icon type={id === ownerData.get('id') ? 'check' : 'stop'} />
            },
            {
                title: msgs.homes.detail.userEmail,
                dataIndex: 'email',
                key: 'email'
            },
            {
                title: msgs.actionsLabel,
                key: 'action',
                className: 'text-right',
                render: (text, record) =>
                    !isOwnerOfHouse && !isInstaller && !isAdmin ? null : (
                        <span style={{ float: 'right' }}>
                            <ButtonGroup style={{ marginLeft: 10 }}>
                                <Button
                                    type="danger"
                                    onClick={this.onDeleteModalShownToggle(true, record)}
                                >
                                    <Icon type="delete" />
                                </Button>
                            </ButtonGroup>
                        </span>
                    )
            }
        ];
        return [
            <Card
                loading={isLoading}
                key="users-table-card"
                bodyStyle={{ padding: 0 }}
                title={
                    !isLoading &&
                    ownerData &&
                    `${msgs.homes.detail.owner}: ${ownerData.get('name')} ${ownerData.get('surename')}`
                }
                extra={
                    isLoading
                        ? undefined
                        : [
                              isOwnerOfHouse || isInstaller || isAdmin ? (
                                  <Button
                                      key="add-detail-user"
                                      size="large"
                                      type="primary"
                                      onClick={this.toggleAddOrEditModal}
                                  >
                                      <Icon type="plus" />
                                      {msgs.homes.addHomeResident}
                                  </Button>
                              ) : null
                          ]
                }
            >
                {(userList && userList.size > 0) || ownerData ? (
                    <Table pagination={false} dataSource={userListSorted} columns={columns} />
                ) : (
                    <Empty
                        description={<span>{msgs.noDataAvailable}</span>}
                        style={{ margin: '30px auto' }}
                    />
                )}
            </Card>,
            (isOwnerOfHouse || isInstaller) && <InvitedUsersTable key="invited-users-table" params={params} />,
            recordToDelete && (
                <Modal
                    key="delete-user-modal"
                    visible={deleteModalShown}
                    onCancel={this.onDeleteModalStateReset}
                    onOk={this.onDeleteUser}
                    okText={msgs.delete}
                    okType="danger"
                    confirmLoading={deleteModalIsLoading}
                    cancelText={msgs.cancel}
                    title={msgs.sureToDeleteTitle}
                >
                    <Spin spinning={deleteModalIsLoading} size="large">
                        <div>
                            <p>
                                {msgs.homes.detail.sureToDeleteContent}{' '}
                                <strong>
                                    {recordToDelete.name} {recordToDelete.surename}
                                </strong>
                                ?
                            </p>
                        </div>
                    </Spin>
                </Modal>
            )
        ];
    }
}

export { UsersTab };
